module.exports = __webpack_public_path__ + "static/media/orange_logo.0f3df967.png";